import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';

import useAlert from 'hooks/useAlert';

import { setPaymentResult } from 'pages/Topbar/ChargeAccount/ChargeAccountSlice';

import axios from 'services/axios';
import { PAYMENT } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';

let popup;

const MakeChargePayTrPaymentButton = ({ nextStep, selectedSavedCard, label, chargeCODWallet }) => {
	const dispatch = useDispatch();
	const formMethods = useFormContext();
	const { showError } = useAlert();
	const { watch, handleSubmit } = formMethods;

	const { loading } = useSelector((state) => state?.layout);

	const checkPayment = async (id) => {
		dispatch(setLoading(true));
		axios
			.post(PAYMENT.CHECK_PAYMENT, { ID: id })
			.then((res) => {
				const { data, status } = res;
				if (status === 200 && data) {
					if (data.status !== 'pending') {
						dispatch(setPaymentResult(data));
						dispatch(setLoading(false));
						nextStep(data);
					} else {
						setTimeout(() => {
							checkPayment(id);
						}, 3 * 1000);
					}
				} else {
					showError();
					AppLogger.error(res);
				}
			})
			.catch((error) => {
				showError();
				AppLogger.error(error);
				dispatch(setLoading(false));
			});
	};

	const completeCreditPayment = async () => {
		dispatch(setLoading(true));
		await chargeCODWallet?.();
		popup = window.open('/payment-redirect-tr.html', '_blank');

		try {
			let payload;

			if (selectedSavedCard) {
				payload = {
					subtotal: watch('subTotal'),
					cvv: watch('cvvForSavedCard'),
					cardID: selectedSavedCard?.ID,
					code: watch('promoCode')
				};
			} else {
				payload = {
					subtotal: watch('subTotal'),
					ccOwner: watch('cardHolderName'),
					cardNumber: watch('cardNumber')?.replace?.(/\s/g, ''),
					expiryMonth: watch('cardExpiry')?.split('/')[0].toString(),
					code: watch('promoCode'),
					expiryYear: watch('cardExpiry')?.split('/')[1].toString(),
					cvv: watch('cvv'),
					saveCard: watch('saveCard')
				};
			}

			if (watch('codWallet')) {
				payload.codWalletAmount = watch('codWallet');
			}

			const response = await axios.post(PAYMENT.MAKE_CHARGE_PAYTR, payload);

			const { data, status } = response;

			if (status === 200 && data.success) {
				checkPayment(data.paymentID);
				popup.document.write(data.response);
				popup.document?.body?.onload?.();
				if (!data.response) {
					popup.close();
				}
			} else {
				popup.close();
				showError();
				AppLogger.error(data);
				dispatch(setLoading(false));
			}
		} catch (error) {
			popup.close();
			dispatch(setLoading(false));
			if (error.response?.data.code === 'error.P002') {
				showError({
					message: 'errorMsg.invalidPromoCode'
				});
			} else {
				showError();
				AppLogger.error(error);
			}
		}
	};

	return (
		<Button
			label={label || 'completePayment'}
			loading={loading}
			onClick={handleSubmit(completeCreditPayment, AppLogger.error)}
			className="payment-form-button"
		/>
	);
};

export default MakeChargePayTrPaymentButton;
